import React, { useEffect } from 'react';
import { withRouter, WithRouterProps } from 'react-router';
import EventTracking from 'lib/EventTracking';
import CoachingHeading from 'coaching/components/CoachingHeading';
import { submitCodeAndSignIn, requestConfirmationCode } from 'auth/components/ConfirmDevice';
import ConfirmEmailForm from 'coaching/components/TutoringSelfServeView/ConfirmEmailForm';
import Copy from 'components/Copy';
import Row from 'components/Row';

export type Props = {
  email: string;
  onChangeEmail: () => void;
  onConfirmationDone?: () => void;
  setLoading: (loadingConfirmation: boolean) => void;
};

function ConfirmEmailView(props: Props & WithRouterProps) {
  const { email, onConfirmationDone, onChangeEmail, router } = props;

  useEffect(() => {
    EventTracking.trackKey('tutoring_self_schedule_purchase.device_confirmation.view', {
      data: JSON.stringify({ email }),
    });
    requestConfirmationCode(email, 'Code sent');
  }, [email]);

  const onSubmitCode = (code: string) => {
    props.setLoading(true);
    EventTracking.trackKey('tutoring_self_schedule_purchase.device_confirmation.confirm.click', {
      data: JSON.stringify({ email }),
    });
    return submitCodeAndSignIn(email, code, router, () => {
      props.setLoading(false);
      if (onConfirmationDone) onConfirmationDone();
    });
  };
  const onResendCode = () => requestConfirmationCode(email, 'Code successfully resent');

  return (
    <>
      <CoachingHeading>Confirm via email</CoachingHeading>
      <Row size="small">
        <Copy align="left" size="small">
          Please enter the 4-digit code sent to
        </Copy>
        <Copy align="left" size="small" weight="bold" data-test="email">
          {email}
        </Copy>
      </Row>
      <ConfirmEmailForm
        onSubmitCode={onSubmitCode}
        onResendCodeClick={onResendCode}
        onChangeEmailClick={onChangeEmail}
      />
    </>
  );
}

export default withRouter(ConfirmEmailView);
